import { atom } from "recoil";

// The window Id that is currently controlling the play/pause on the timeline
// null if no window's timeline is currently playing.
export const linkedWindowsTimelineControllerAtom = atom<string | null>({
    key: "linkedWindowsTimelineController",
    default: null
})